
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"39.849","height":"22.425","viewBox":"0 0 39.849 22.425"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Pfad 359","d":"M2.5 19.925L19.925 2.5 37.35 19.925","fill":"none","stroke":"#783723","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}})])
          )
        }
      }
    